import bossci from './bossci'
import ce2 from './ce2'
import child from './child'
import document_model from './document_model'
import fw from './fw'
import fwinvoice from './fwinvoice'
import hooks from './hooks'
import mrg from './mrg'
import njasbestos from './njasbestos'
import njcal from './njcal'
import tkcal from './tkcal'
import totb from './totb'
import smtc from './smtc'
import woodcosts from './woodcosts'

const allHooks = {
  bossci,
  ce2,
  child,
  document_model,
  fw,
  fwinvoice,
  hooks,
  mrg,
  njasbestos,
  njcal,
  tkcal,
  totb,
  smtc,
  woodcosts
}

export default allHooks
